import styled from 'styled-components';

export const DivPageFacebook = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    >img{
        width:400px;
        border-radius:250px;
        height:400px;
        margin:0 15px 25px 0;
    }

`;
